import { useState, useEffect } from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Button,
  Chip,
  Stack,
  Alert,
} from '@mui/material';
import UserService from '../../services/user.service';
import { PERMISSION_TEXTS } from '../../pages/ProfileUser/permissions';


const UserPermissionsTable = ({
  user,
}) => {

  console.log("Rendering UserPermissionsTable for user:", user);


  const [permissions, setPermissions] = useState([]);

  const handleTogglePermission = async (permissionId, nextAssigned) => {
    const updatePermission = await UserService.updateUserPermissions(
      user?.id,
      permissionId,
      nextAssigned
    );

    if (updatePermission?.error) {
      Alert.error("No se pudo actualizar el permiso.");
      return;
    }

    setPermissions((prev) =>
      prev.map((p) =>
        p.id === permissionId ? { ...p, assigned: nextAssigned } : p
      )
    );
  };

  const getPermissions = async () => {
    try {
      const { data: allPermissions } = await UserService.getAllPermissions();
      const userPermissionNames = await UserService.getUserPermissions(user.id);

      const userPermSet = new Set(userPermissionNames);

      const merged = allPermissions.map((p) => ({
        ...p,
        id: p?.id,
        assigned: userPermSet.has(p.permissions),
        description: PERMISSION_TEXTS[p.permissions] ?? p.permissions,
      }));

      setPermissions(merged);
    } catch (error) {
      console.error("Error fetching permissions:", error);
    }
  };

  useEffect(() => {
    getPermissions();
  }, [user]);





  return (
    <Paper elevation={3} sx={{ p: 2 }}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <div>
          <Typography variant="h6">
            Permisos de {user?.userName}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Asigná o quitá permisos para este usuario.
          </Typography>
        </div>
      </Stack>

      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Permiso</TableCell>
              <TableCell>Descripción</TableCell>
              <TableCell align="center">Estado</TableCell>
              <TableCell align="right">Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {permissions?.map((perm, index) => {
              return (
                <TableRow key={perm.id}>
                  <TableCell>
                    <Typography variant="subtitle2">
                      {perm.permissions}
                    </Typography>
                  </TableCell>


                  <TableCell>
                    <Typography variant="body2">
                      {perm.description || '—'}
                    </Typography>
                  </TableCell>

                  <TableCell align="center">
                    {perm.assigned ? (
                      <Chip label="Asignado" color="success" size="small" />
                    ) : (
                      <Chip label="No asignado" size="small" />
                    )}
                  </TableCell>

                  <TableCell align="right">
                    <Button
                      size="small"
                      variant={perm.assigned ? 'outlined' : 'contained'}
                      color={perm.assigned ? 'error' : 'primary'}
                      onClick={() => handleTogglePermission(perm.id, !perm.assigned)}
                    >
                      {perm.assigned ? 'Quitar' : 'Asignar'}
                    </Button>
                  </TableCell>
                </TableRow>
              );
            })}


            {permissions?.length === 0 && (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  <Typography variant="body2" color="text.secondary">
                    No hay permisos configurados.
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default UserPermissionsTable;
